import { render, staticRenderFns } from "./Vision.vue?vue&type=template&id=6decbe54&scoped=true&"
import script from "./Vision.vue?vue&type=script&lang=js&"
export * from "./Vision.vue?vue&type=script&lang=js&"
import style0 from "./Vision.vue?vue&type=style&index=0&id=6decbe54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6decbe54",
  null
  
)

export default component.exports